<template>
  <div v-animation:bottom.delay class="t-lk-competencies-item">
      <div class="t-lk-competencies-item__top">
          <div class="t-lk-competencies-item__img">
            Компетенции вашей организации
          </div>
      </div>
      <!-- {{ legalInfo }} -->
      <div class="t-lk-competencies-item__row">
        <div class="t-lk-competencies-item__subtitle">Лиценизия ФСБ</div>
        <div class="t-lk-competencies-item__value">{{ legalInfo.fsb.value ? 'Загружено' : 'Отсутсвует' }}</div>
      </div>
      <div class="t-lk-competencies-item__row">
        <div class="t-lk-competencies-item__subtitle">Лиценизия ФСТЭК</div>
        <div class="t-lk-competencies-item__value">{{ legalInfo.fstek.value ? 'Загружено' : 'Отсутсвует' }}</div>
      </div>
      <div
          class="t-lk-competencies-item__btn t-btn _border-gray _lk"
          @click="checkValidate"
      >
          <!-- <template v-if="item.moderation === 2">{{ $root.staticText.lk.mainEdit }}</template> -->
        {{ $root.staticText.lk.mainUpdate }}
      </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
  import Vue from "vue";

  export default {
      name: "lk-competencies-item",
      computed: {
          ...mapState('lk/competencies', {
            legalInfo: state => state.legalInfo,
            currencies: state => state.currencies
          }),
          ...mapGetters('lk', {
            profile: 'profile',
        }),
      },
      methods: {
        ...mapMutations('lk', ['setProfileItem']),
        ...mapActions('modal', [
          'modalType_competenciesOpen',
          'modalType_missingDataOpen',
          'modalType_myOrganisationCompetenciesOpen',
        ]),

        updateOrganisationInfo () {
          this.modalType_myOrganisationCompetenciesOpen({
            title: this.$root.staticText.lk.compVendor,
            button: this.$root.staticText.forms.btn,
            vendorId: this.profile.id,
            currencies: this.currencies,
            isEdit: true,
          })
        },
        checkValidate () {
          // модалка добавить информацию
          this.updateOrganisationInfo();
          return;
          if (this.profile.validate === 1) {
          }
          
          // модалка заполнить недостающие данные
          if (this.profile.validate === 2) {
            const url = process.env.NODE_ENV !== 'production' ? 'lk/getForm.json' : 'lk/partner/getForm';
            Vue.http.get(url)
              .then(response => response.json())
              .then(
                (data) => {
                  if (data.success) {
                    this.modalType_missingDataOpen({
                        formInfo: data.form,
                        button: this.$root.staticText.forms.btn,
                        overflowNone: true,
                    });
                  }
                },
                () => {}
              );
            return;
          } 
          
          // заглушка, что данные на модерации
          if (this.profile.validate === 3) {
            this.modalType_missingDataOpen({
              moderateText: this.$root.staticText.lk.moderateText,
              overflowNone: true,
            });
            return;
          }
          
          // запрос проверки profile.validate
          const url = process.env.NODE_ENV !== 'production' ? 'lk/isAuth.json' : 'lk/partner/check';
          Vue.http.get(url)
            .then(response => response.json())
            .then(
              (data) => {
                this.setProfileItem({
                  name: 'validate',
                  value: data.success ? 1 : 2
                });
                this.checkValidate(item);
              },
              () => {}
            );
        },
      }
  }
</script>



// WEBPACK FOOTER //
// src/templates/components/lk/lk-competencies-item/lk-competencies-item-legal.vue